export default {
  getVolume: (state) => {
    return state.volume || 0;
  },
};
